import type { AgentWorkspacePolicy } from "@lumen/shared";

export type Draft = {
  name: string;
  slug: string;
  description: string;
  type:
    | "container"
    | "process-sandbox"
    | "rootless-podman"
    | "ssh"
    | "proxmox"
    | "machine";
  workspaceMode: "isolated" | "machine";
  scope: "platform" | "organization" | "personal";
  image: string;
  setupInstructions: string;
  sshHost: string;
  sshPort: number;
  sshUsername: string;
  sshHostKeyFingerprint: string;
  sshHostKeyAlgorithm: string;
  authScope: "global" | "user";
  globalAuthType: "password" | "key";
  password: string;
  privateKey: string;
  passphrase: string;
  startingFolder: string;
  commandPolicy: AgentWorkspacePolicy;
  allowUserPolicyRelaxation: boolean;
  cpuLimit: string;
  memoryLimitMb: string;
  networkEnabled: boolean;
  commandTimeoutSeconds: number | null;
  enabled: boolean;
};

export function createAgentWorkspaceDraft(
  scope: Draft["scope"] = "personal",
): Draft {
  return {
    name: "",
    slug: "",
    description: "",
    type: "container",
    workspaceMode: "isolated",
    scope,
    image: "alpine:latest",
    setupInstructions: "",
    sshHost: "",
    sshPort: 22,
    sshUsername: "",
    sshHostKeyFingerprint: "",
    sshHostKeyAlgorithm: "",
    authScope: "global",
    globalAuthType: "key",
    password: "",
    privateKey: "",
    passphrase: "",
    startingFolder: "",
    commandPolicy: { "*": "ask" },
    allowUserPolicyRelaxation: false,
    cpuLimit: "1",
    memoryLimitMb: "512",
    networkEnabled: false,
    commandTimeoutSeconds: 120,
    enabled: true,
  };
}
